import { IPublicClientApplication, AuthenticationResult, AccountInfo } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

export class AuthService {
  private msalInstance: IPublicClientApplication;

  constructor(msalInstance: IPublicClientApplication) {
    this.msalInstance = msalInstance;
  }

  public async login(): Promise<AuthenticationResult> {
    try {
      return await this.msalInstance.loginPopup(loginRequest);
    } catch (error) {
      console.error("Login failed", error);
      throw error;
    }
  }

  public logout(): void {
    this.msalInstance.logout();
  }

  public getCurrentAccount(): AccountInfo | null {
    const accounts = this.msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      return null;
    }
    return accounts[0];
  }

  public async getAccessToken(): Promise<string> {
    const account = this.getCurrentAccount();
    if (!account) {
      throw new Error("No active account! Please sign in.");
    }

    const response = await this.msalInstance.acquireTokenSilent({
      ...loginRequest,
      account
    });
    
    return response.accessToken;
  }
  
  public async getSharePointToken(spSiteUrl: string): Promise<string> {
    const account = this.getCurrentAccount();
    if (!account) {
      throw new Error("No active account! Please sign in.");
    }
    
    // Get token with SharePoint resource scope
    const response = await this.msalInstance.acquireTokenSilent({
      scopes: [`${spSiteUrl}/.default`],
      account
    });
    
    return response.accessToken;
  }
}